/**
 * Newsletter forms (footer + popup): submit in place, and the once-per-30-days popup.
 * The forms also work without this script (normal POST, redirect back with a message).
 */
const TC = window.TC || {};
const KEY = 'tc-nl';
const endpoint = (TC.wcAjax || '/?wc-ajax=%%endpoint%%').replace('%%endpoint%%', 'tc_subscribe');
const store = {
  get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
  set(v) { try { localStorage.setItem(KEY, JSON.stringify({ ...store.get(), ...v })); } catch (e) { /* storage off */ } },
};

// Fill time stamps (bots that post instantly are ignored server-side).
document.querySelectorAll('[data-news-t]').forEach((i) => { i.value = Math.floor(Date.now() / 1000); });

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('[data-news]')) return;
  e.preventDefault();
  const msg = form.querySelector('.news__msg');
  const email = form.querySelector('input[type="email"]');
  if (!email.value || !email.checkValidity()) {
    msg.textContent = 'Please enter a valid email address.';
    msg.classList.add('is-err');
    email.focus();
    return;
  }
  const btn = form.querySelector('button[type="submit"]');
  btn.disabled = true;
  msg.classList.remove('is-err');
  msg.textContent = 'Signing you up…';
  try {
    const body = new FormData(form);
    body.append('page', location.href);
    const res = await fetch(endpoint, { method: 'POST', body, credentials: 'same-origin' });
    const data = await res.json();
    msg.textContent = data.message || '';
    msg.classList.toggle('is-err', !data.ok);
    if (data.ok) {
      form.classList.add('is-done');
      store.set({ subscribed: Date.now() });
      email.value = '';
    }
  } catch (err) {
    form.submit();
  } finally {
    btn.disabled = false;
  }
});

// Popup: once per 30 days, after the delay or half-page scroll, never for subscribers.
const pop = document.getElementById('newsletter-popup');
if (pop && typeof pop.showModal === 'function') {
  const s = store.get();
  const month = 30 * 24 * 3600 * 1000;
  const recently = (s.seen && Date.now() - s.seen < month) || s.subscribed;
  if (!recently) {
    let shown = false;
    const show = () => {
      if (shown || document.querySelector('dialog[open]') || document.documentElement.classList.contains('cd-open')) return;
      shown = true;
      store.set({ seen: Date.now() });
      pop.showModal();
      removeEventListener('scroll', onScroll);
    };
    const onScroll = () => {
      if (scrollY > (document.documentElement.scrollHeight - innerHeight) / 2) show();
    };
    setTimeout(show, (Number(pop.dataset.delay) || 12) * 1000);
    addEventListener('scroll', onScroll, { passive: true });
  }
  pop.addEventListener('click', (e) => {
    if (e.target.closest('[data-nlpop-close]') || e.target === pop) pop.close();
  });
}
